import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import classNames from 'classnames/bind';

import styleIcon from '../../blocks/icon/style.pcss';
import styleGrid from '../../blocks/grid/style.pcss';
import { check, uncheck } from '../../blocks/checked/actions';

import config from 'config';

import style from './style.pcss';

const classnames = classNames.bind(style);
const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    ...draggableStyle
});

@connect((state) => ({
    sports      : state.sports,
    checked     : state.checked.items,
    checkedCount: state.checked.eventsCount,
    tournaments : state.tournaments.items,
    isLoaded    : state.tournaments.isLoaded
}), (dispatch) => ({
    dispatchUncheck: (params) => dispatch(uncheck(params)),
    dispatchCheck  : (params) => dispatch(check(params))
}))
class Sports extends Component {

    static displayName = '[block] sports';

    static propTypes = {
        sports: PropTypes.shape({
            items: PropTypes.arrayOf(PropTypes.shape({
                gameId: PropTypes.number,
                title : PropTypes.string,
                qty   : PropTypes.number
            })),
            selected       : PropTypes.number,
            total          : PropTypes.number,
            isVisibleSports: PropTypes.bool
        }),
        dispatchCheck  : PropTypes.func,
        dispatchUncheck: PropTypes.func,
        checked        : PropTypes.object,
        onClickHandler : PropTypes.func,
        isLoaded       : PropTypes.bool,
        checkedCount   : PropTypes.number
    };

    state = {
        checkedAllSports: false
    };

    static getDerivedStateFromProps(nextProps) {
        return {
            checkedAllSports: Boolean(nextProps.sports.total) && nextProps.sports.total === nextProps.checkedCount
        };
    }

    componentDidUpdate() {
        const { checked, sports, tournaments } = this.props;

        sports.isVisibleSports && sports.items.forEach((sport) => {
            const lengthSport = tournaments[sport.gameId] && tournaments[sport.gameId].length;

            this[`input-${sport.gameId}`].indeterminate = Array.isArray(checked[sport.gameId]) && checked[sport.gameId].length !== lengthSport;
        })
    }

    selectSportHundle = (sport) => (e) => {
        e.stopPropagation();

        this.selectSport(sport, e.currentTarget.checked);
    };

    selectAllSportsHundle = (e) => {
        this.props.sports.items.forEach((item) => {
            this.selectSport(item, e.currentTarget.checked, 'allSports');
        });

        this.setState({ checkedAllSports: !this.state.checkedAllSports })
    };

    selectSport = (sport, checked, type = 'sports') => {
        const { sports: { total }, tournaments, dispatchUncheck, dispatchCheck } = this.props;

        if(checked) {
            dispatchCheck({
                kind                 : type,
                totalCountTournaments: type === 'sports' ? null : total,
                sport
            })
        } else {
            dispatchUncheck({
                kind             : type,
                globalTournaments: tournaments,
                sport
            })
        }
    };

    render() {
        if(!this.props.sports.isVisibleSports) {
            return null;
        }

        return (
            <div className={`${styleGrid['grid__main-sports']} ${style['sports']}`}>
                <div className={style['sports__select-all']}>
                    <input className={style['sports__select-all-checkbox']} type="checkbox" checked={this.state.checkedAllSports} onChange={this.selectAllSportsHundle} />
                    <span className={style['sports__select-all-label']}>Все виды спорта</span>
                    <span className={style['sports__select-all-amount']}>{this.props.sports.total}</span>
                </div>
                <div className={style['sports__scrollable']}>
                    <div className={style['sports__scroll-container']}>
                        <Droppable droppableId="sports" type="SPORTS">
                            {(provided) => (
                                <div className={style['sports__scroll-content']} ref={provided.innerRef}>
                                    {this.props.sports.items.map((item, index) => (
                                        <Draggable key={item.gameId} draggableId={item.gameId} index={index} type="SPORTS">
                                            {(provided, snapshot) => (
                                                <div>
                                                    <div
                                                        className={classnames('sports__item', {
                                                            sports__item_selected: this.props.sports.selected === item.gameId // eslint-disable-line camelcase
                                                        })}
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style
                                                        )}
                                                        onClick={this.props.onClickHandler(item.gameId)}
                                                    >
                                                        <input
                                                            className={style['sports__checkbox']}
                                                            type="checkbox"
                                                            ref={(input) => { this[`input-${item.gameId}`] = input; }}
                                                            onChange={this.selectSportHundle(item)}
                                                            checked={this.props.checkedCount && Boolean(this.props.checked[item.gameId])}
                                                        />
                                                        <span className={`${styleIcon['icon']} ${styleIcon['icon_sports']} ${styleIcon[config.sportsIcons[item.gameId]] !== undefined ? styleIcon[config.sportsIcons[item.gameId]] : styleIcon['icon_default']}`} />
                                                        <span className={style['sports__label']}>{item.title}</span>
                                                        <span className={style['sports__amount']}>{item.qty}</span>
                                                    </div>
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </div>
                </div>
            </div>
        )
    }

}

export default Sports;



// WEBPACK FOOTER //
// ./src/blocks/sports/index.js